export function isMaintenancePreviewEmbed(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.self !== window.top) return true;
  return document.documentElement.classList.contains('maintenance-embed-preview')
    || document.body.classList.contains('maintenance-embed-preview');
}

/** True when PRO04 voice preview should bypass server auth / ElevenLabs. */
export function shouldUseLocalVoicePreview(): boolean {
  if (typeof window === 'undefined') return false;

  if (isMaintenancePreviewEmbed()) return true;

  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return true;

  return Boolean(import.meta.env.DEV);
}

export function isVoicePreviewAuthError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const record = error as { status?: number; error?: string };
  return record.status === 401
    || /authentication required/i.test(record.error || '');
}
